// ---------------------------------------------------------------------------
// Per-user access overrides — exceptions to the role-based permission matrix
// in SPEC_roles-and-permissions.md.
//
// Normally, what a person can see and do is decided entirely by their Entra
// role (Director, Executive, RegionalManager, LiaisonManager, Liaison). This
// file is the ONE place we grant a specific person a few EXTRA capabilities on
// top of their role — without promoting them to a higher role.
//
// HOW IT WORKS
//   • Each key is the person's portal sign-in email, in lowercase.
//   • Each value lists the capability flags to force ON for that person.
//   • Capability names must match the flags in usePermissions.js.
//
// Anything listed here is ADDED to what the person's role already grants — it
// never takes access away. To revoke a custom grant, delete the relevant line
// (or the whole entry). To grant the same exception to someone else, add a new
// entry with their email.
//
// IMPORTANT: the email must EXACTLY match how the person signs in (the address
// on their Microsoft 365 / Entra account). If it doesn't match, the override
// silently does nothing.
// ---------------------------------------------------------------------------

export const ACCESS_OVERRIDES = {
  // Jim Deslierres — Regional Manager (SHAP) who also runs supplier
  // relationships and authors sales proposals. On top of his Regional Manager
  // role he can: open the Sales page, create/edit/send sales proposals, and
  // add/edit suppliers. (He does NOT get the Director-only Sales Resource
  // uploads, Billing Manager, Invoices, or team admin.)
  'jim.deslierres@proxemicsconsulting.com': {
    canSeeSales: true,
    canManageProposals: true,
    canEditSuppliers: true,
    canAddSuppliers: true,
  },
};

/**
 * Returns the extra-capability map for a given email (case-insensitive).
 * Returns an empty object when the user has no custom overrides.
 */
export function overridesFor(email) {
  if (!email) return {};
  return ACCESS_OVERRIDES[email.trim().toLowerCase()] || {};
}
